import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Card, CardContent, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import img from "../assets/qural1.png";
import MailIcon from '@mui/icons-material/Mail';
import { makeApiRequest } from '../utils/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Email is required.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await makeApiRequest('post', '/api/forgot-password/send-otp', { email });
      if (response.status === 'success') {
        navigate('/verify-otp', { state: { email } });
      } else {
        setError(response.message || 'Invalid email.');
      }
    } catch (err) {
      console.error('Error sending OTP:', err);
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Box
        sx={{
          width: '100%',
          height: '60vh',
          background: 'linear-gradient(to right, #2353A3 0%, #59C8F2 50%, #FFFFFF 100%)',
        }}
      />
      <Box
        sx={{
          width: 0,
          height: 0,
          borderLeft: '100vw solid transparent',
          borderBottom: '13.9vw solid #ffffff',
          marginTop: '-13.8vw',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '50%', md: "35%" },
          padding: '20px',
          backgroundColor: 'transparent',
          zIndex: 10,
        }}
      >
        <Card sx={{ borderRadius: '8px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
          <CardContent>
            <Typography variant="h5" component="h2" sx={{ marginBottom: '30px', color: '#333', textAlign: 'center' }}>
              <img style={{ height: "122px", objectFit: 'contain', width: '100%' }} src={img} alt="Logo" />
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
              Forgot Password
            </Typography>
            {error && (
              <Typography variant="body2" color="error" sx={{ marginBottom: 2, textAlign: 'center' }}>
                {error}
              </Typography>
            )}
            <Box component="form" onSubmit={handleSendOtp} noValidate>
              <Box sx={{ marginBottom: 4 }}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  placeholder="Enter your email"
                  variant="outlined"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    endAdornment: <MailIcon />,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  backgroundColor: '#007BFF',
                  '&:hover': { backgroundColor: '#0056b3' },
                  marginBottom: 2
                }}
              >
                {loading ? 'Sending...' : 'Send OTP'}
              </Button>
              <Box sx={{ textAlign: 'center' }}>
                <Link
                  component="button"
                  type="button"
                  onClick={() => navigate('/login')}
                  sx={{ fontSize: '14px', color: '#007BFF', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                  Back to Login
                </Link>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default ForgotPassword;
